module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/luggage-icon-0d7188844720c1be2b467e98e82c8abe.svg";